module.exports = __webpack_public_path__ + "fonts/AvertaStd-ExtraBold.ttf";